import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        // Extending the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary display for the tree column.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        // Returning the layout configuration for the view
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Defining a tree table view
                            id: 'treetable', // Unique identifier for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            scroll: 'xy', // Enabling both horizontal and vertical scrolling
                            bready: function () {
                                this.openAll(); // Expanding all rows when ready
                            },
                            columns: [
                                // Defining columns for the tree table
                                {
                                    id: 'Fecha', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Displaying group value
                                            );
                                        return obj.Fecha; // Returning the date value
                                    },
                                },
                                {
                                    id: 'CantidadTickets',
                                    header: _('Cantidad Tickets'),
                                    format: webix.i18n.intFormat, // Formatting as integer
                                    width: 80,
                                },
                                {
                                    id: 'Stake',
                                    header: _('Apuesta'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'StakePromedio',
                                    header: _('Apuesta Promedio'),
                                    format: webix.i18n.numberFormat,
                                    width: 80,
                                },
                                {
                                    id: 'TaxBet',
                                    header: _('Impuesto Apuesta'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'Tax',
                                    header: _('Impuesto Premios'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'Payout',
                                    header: _('Premios'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'Bonos',
                                    header: _('Bonos'),
                                    format: webix.i18n.intFormat,
                                    width: 80,
                                },
                                {
                                    id: 'Ggr',
                                    header: _('GGR'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'GgrPorc',
                                    header: _('GGR %'),
                                    format: percentFormat, // Using the custom percentage format
                                    width: 100,
                                },
                                {
                                    id: 'UsersRegistered',
                                    header: _('Usuarios Registrados'),
                                    format: webix.i18n.intFormat,
                                    width: 90,
                                },
                                {
                                    id: 'FirstDeposits',
                                    header: _('Primeros Depósitos'),
                                    format: webix.i18n.intFormat,
                                    width: 100,
                                },
                                {
                                    id: 'Moneda',
                                    header: _('Moneda'),
                                    width: 75,
                                },
                            ],
                            on: {
                                // Event handlers for the tree table
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Displaying loading overlay before data load
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hiding loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Checking if there are no data items
                                    webix.extend(this, webix.OverlayBox); // Extending with overlay capabilities
                                    this.showOverlay(
                                        // Displaying no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disabling automatic width adjustment
                            math: true, // Enabling mathematical operations on the data
                            datafetch: 10, // Number of data items to fetch at a time
                            pager: 'pagerA', // Identifier for the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('treetable'); // Getting the tree table instance
        var url = devConfig.geturlApi() + 'es/Financial/GetInformeGerencial2'; // API endpoint for data retrieval
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                // Grouping data by country and partner
                by: function (obj) {
                    return (
                        "<i class='flags " +
                        obj.CountryIcon +
                        "'></i>" +
                        obj.Pais +
                        ' ' +
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner; // Filtering partner image
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    );
                },
                map: {
                    // Mapping fields for aggregation
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: [
                        'StakePromedio',
                        function (prop, data) {
                            console.log('data:: ', data); // Logging data for debugging
                            if (!data.length) return 0; // Returning 0 if no data
                            var summ1 = 0; // Sum for stakes
                            var summ2 = 0; // Sum for ticket counts
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Logging each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Summing stakes
                                summ2 = summ2 + Math.floor(data[i].CantidadTickets); // Summing ticket counts
                            }
                            console.log(summ1); // Logging total stakes
                            console.log(summ2); // Logging total tickets
                            return summ1 / summ2; // Returning average stake
                        },
                    ],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    GgrPorc: [
                        'GgrPorc',
                        function (prop, data) {
                            console.log('data:: ', data); // Logging data for debugging
                            if (!data.length) return 0; // Returning 0 if no data
                            var summ1 = 0; // Sum for stakes
                            var summ2 = 0; // Sum for GGR
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Logging each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Summing stakes
                                summ2 = summ2 + Math.floor(data[i].Ggr); // Summing GGR
                            }
                            console.log(summ1); // Logging total stakes
                            console.log(summ2); // Logging total GGR
                            return (summ2 / summ1) * 100; // Returning GGR percentage
                        },
                    ],
                    UsersRegistered: ['UsersRegistered', 'sum'],
                    FirstDeposits: ['FirstDeposits', 'sum'],
                    Partner: ['Partner'], // Mapping partner field
                },
            });
            $$('treetable').data.group({
                // Grouping data by partner
                by: function (obj) {
                    return (
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner; // Filtering partner image
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    );
                },
                map: {
                    // Mapping fields for aggregation
                    Partner: ['Partner'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: [
                        'StakePromedio',
                        function (prop, data) {
                            console.log('data:: ', data); // Logging data for debugging
                            if (!data.length) return 0; // Returning 0 if no data
                            var summ1 = 0; // Sum for stakes
                            var summ2 = 0; // Sum for ticket counts
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Logging each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Summing stakes
                                summ2 = summ2 + Math.floor(data[i].CantidadTickets); // Summing ticket counts
                            }
                            console.log(summ1); // Logging total stakes
                            console.log(summ2); // Logging total tickets
                            return summ1 / summ2; // Returning average stake
                        },
                    ],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    GgrPorc: [
                        'GgrPorc',
                        function (prop, data) {
                            console.log('data:: ', data); // Logging data for debugging
                            if (!data.length) return 0; // Returning 0 if no data
                            var summ1 = 0; // Sum for stakes
                            var summ2 = 0; // Sum for GGR
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Logging each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Summing stakes
                                summ2 = summ2 + Math.floor(data[i].Ggr); // Summing GGR
                            }
                            console.log(summ1); // Logging total stakes
                            console.log(summ2); // Logging total GGR
                            return (summ2 / summ1) * 100; // Returning GGR percentage
                        },
                    ],
                    UsersRegistered: ['UsersRegistered', 'sum'],
                    FirstDeposits: ['FirstDeposits', 'sum'],
                },
            });
        });

        // Event listener for filtering data based on user input
        this.on(this.app, 'informeGerencial:filter', (filterData) => {
            var object = Object.entries(filterData); // Converting filter data to entries
            var string1 = ''; // Query string for API request
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Splitting date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Adding end date to query
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding other filter parameters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Formatting date
                                string1 = string1 + '&dateFrom=' + date; // Adding date to query
                                string1 = string1 + '&dateTo=' + date; // Adding date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Converting nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Creating date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adding start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Creating date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adding end date to query
                                    }
                                }
                            }
                        }
                        if (object[i][0] === 'Date') {
                            var d = new Date(object[i][1]); // Creating date object for single date
                            var dateFrom =
                                'dateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + d.getDate()).slice(-2);
                            string1 = string1 + '&' + dateFrom; // Adding date to query
                            var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0); // Getting last day of the month
                            var dateTo =
                                'dateTo=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + ud.getDate()).slice(-2);
                            string1 = string1 + '&' + dateTo; // Adding end date to query
                        }
                    }
                }
            }
            grid.clearAll(); // Clearing existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loading new data with filters
            $$('filterPopup').hide(); // Hiding the filter popup
        });

        // Event listener for item click to navigate to user details
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Getting the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Triggering user detail event
        });

        // Event listener for player selection to filter grid data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Loading data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
